module.exports = __webpack_public_path__ + "img/traffic-junction-4.4999e837.jpg";